import { render, staticRenderFns } from "./SearchQueryBox.vue?vue&type=template&id=157a3582&"
import script from "./SearchQueryBox.vue?vue&type=script&lang=js&"
export * from "./SearchQueryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports